import React, { Component } from "react";
import { connect } from "react-redux";
import { resetPassword, clearAuth } from "../../actions";
import { Field, reduxForm } from "redux-form";
import { Link } from "react-router-dom";
import * as util from "../../shared/utility";

class ResetPassword extends Component {
  componentWillUnmount() {
    this.props.clearAuth();
  }

  onSubmit = (formValues) => {
    this.props.resetPassword(formValues.email);
  };

  render() {
    var divStyleDesktop = {
      background: "#ddd",
      marginTop: "60px",
    };

    let errorMessage = null;
    if (this.props.authError) {
      errorMessage = (
        <p className="ui error message">{this.props.authErrorMessage}</p>
      );
    }

    let successMessage = null;
    if (this.props.authSuccess) {
      successMessage = (
        <p className="ui message">{this.props.authSuccessMessage}</p>
      );
    }

    return (
      <div>
        <div className="ui grid stackable">
          <div className="three wide column computer tablet only" />
          <div className="ten wide column">
            <div
              className="ui middle aligned center aligned column segment"
              style={divStyleDesktop}
            >
              <form
                onSubmit={this.props.handleSubmit(this.onSubmit)}
                className="ui form error"
              >
                <Field
                  name="email"
                  component={util.RenderInput}
                  // component={this.renderInput}
                  label="Email"
                  type="text"
                />

                <div className="ui three column grid">
                  <div className="column"></div>
                  <div className="column">
                    {!this.props.authSuccess && (
                      <button
                        disabled={this.props.authRequest}
                        className="ui button primary"
                      >
                        Reset Password
                      </button>
                    )}
                  </div>
                  <div className="column bottom aligned ">
                    {/* <div
                      className="ui right floated item"
                      onClick={() => alert("pwahpwah")}
                    >
                      Login
                    </div> */}
                    <Link className="ui right floated item" to={"/login"}>
                      Login
                    </Link>
                  </div>
                </div>
              </form>
              {errorMessage}
              {successMessage}
            </div>
          </div>
          <div className="three wide column computer tablet only" />
        </div>
      </div>
    );
  }
}

const validate = (formValues) => {
  const errors = {};

  if (!formValues.email) {
    errors.email = "You must enter an email address.";
  }

  return errors;
};

const mapStateToProps = (state) => {
  return {
    authRequest: state.auth.authRequest,
    authError: state.auth.authError,
    authErrorMessage: state.auth.authErrorMessage,
    authSuccess: state.auth.authSuccess,
    authSuccessMessage: state.auth.authSuccessMessage,
  };
};

const resetPasswordComponent = connect(mapStateToProps, {
  resetPassword,
  clearAuth,
})(ResetPassword);

export default reduxForm({
  form: "resetPasswordForm",
  validate,
})(resetPasswordComponent);
